export default class {
    _Id;
    _Name;
    _FileName;
    _Organization;

    get Id() {
        return this._Id;
    }

    set Id(value) {
        this._Id = value;
    }

    get Name() {
        return this._Name;
    }

    set Name(value) {
        this._Name = value;
    }

    get FileName() {
        return this._FileName;
    }

    set FileName(value) {
        this._FileName = value;
    }

    get Organization() {
        return this._Organization;
    }

    set Organization(value) {
        this._Organization = value;
    }

    constructor(id, name, fileName, organization) {
        this._Id = id;
        this._Name = name;
        this._FileName = fileName;
        this._Organization = organization;
    }
}